import React, { useContext, useEffect, useState } from "react";
import { Button,Stack, Card,TextField, FormLabel,FormControl,FormControlLabel, RadioGroup,Radio, Checkbox, Container, FormGroup, IconButton, InputAdornment, Modal, Typography } from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

import dayjs from 'dayjs';
import { getFileExtension } from "../../../utility/helper";
import { getNegativeValueInAccountingForm } from '../../../utility/format-display-output';
import CustomDateField from "../../../Container/custom-date-field";
import SourceIdVerificationComp from "./common/SourceIdVerificationComp";
import dashboardServices from "../../../services/hoa-dashboard-api-service";
import { GlobalContext } from '../../../context/hoa-global-context';
import hoaDatastore from "../../../store/hoa-datastore";
import { useSelectedTaskStoreStore } from "../../../store/useTaskStore";

const HoaDuesModal = ({
    propertyData,
	open,
	handleClose,
    updateIndex,
    setUpdateIndex,
    hoaDue,
    setHoaDue,
    hoaDueList,
    setHoaDueLists
}: any) => {
    const [error, setError] = useState(false);
    const [files, setFiles] = useState([]);
    const [sourceIdStatus, setSourceIdStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emailFilesOptions, setEmailFilesOptions] = useState([]);
    const [selectedFileFromEmail, setSelectedFileFromEmail] = useState([]);
    const [selectedFileFromMail, setSelectedFileFromMail] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [documentIndex, setDocumentIndex] = useState(null);
    const { property, activeMenu } = useContext<any>(GlobalContext);
    const { findDataMatchWithSelectedValue } = useSelectedTaskStoreStore()

    useEffect(() => {
        if (activeMenu === 'propertiespendingtask' && open === true && !hoaDue.objectId) {
            const selectedProperty = hoaDatastore.getIdFromUrl();
            const propertyValue = findDataMatchWithSelectedValue(property.data, hoaDatastore);
            if(!propertyValue) return;
            if(propertyValue?.taskSourceType === 'mail') {
                const propertyConnectedWithMail = propertyValue?.mailDetails?.propertyList || [];
                const isPropertyIncluded = propertyConnectedWithMail.find(
                    (property: any) => property.objectId === selectedProperty
                );
                if (isPropertyIncluded) {
                    setSourceIdStatus("verified");
                    setHoaDue({
                        ...hoaDue,
                        sourceIdType: "mail",
                        sourceId: propertyValue?.mailDetails?.id || "",
                        newHoaDueFileToUpload: [propertyValue?.mailDetails?.attachmentDetails?.name],
                    });
                }
            } else if(propertyValue?.taskSourceType === 'email') {
                const propertyConnectedWithMail = propertyValue?.emailDetails?.propertyList || [];
                const isPropertyIncluded = propertyConnectedWithMail.find(
                    (property: any) => property.objectId === selectedProperty
                );
                console.log(propertyValue?.emailDetails?.attachmentDetails)
                if (isPropertyIncluded) {
                    setSourceIdStatus("verified");
                    setHoaDue({
                        ...hoaDue,
                        sourceIdType: "email",
                        sourceId: propertyValue?.emailDetails?.id || "",
                        newHoaDueFileToUpload: propertyValue?.emailDetails?.attachmentDetails || [],
                    });
                }
            }
            return;
        }
    },[open])

	const onClose = () => {
        setError(false);
        setHoaDue({});
        setFiles([]);
        setUpdateIndex(null);
        setDocumentIndex(null);
        setSourceIdStatus(null);
        setSelectedFileFromMail(null);
        setSelectedFileFromEmail([]);
		handleClose();
	};

    useEffect(() => {
        if(activeMenu === 'propertiespendingtask' && !hoaDue?.objectId) return;

        if (sourceIdStatus === "verified") {
            setSourceIdStatus("");
        }
    }, [hoaDue.sourceIdType, hoaDue.sourceId]);

    useEffect(() => {
        if (updateIndex >= 0) {
            setSourceIdStatus('verified');
        }
    }, [updateIndex]);

    useEffect(() => {
        setSelectedFileFromMail(null);
        setSelectedFileFromEmail([]);
        setEmailFilesOptions([]);
    }, [hoaDue.sourceIdType])

    useEffect(() => {
        if (open) {
            if(hoaDue?.hoaDuesNoticeFiles){
                setFiles(hoaDue.hoaDuesNoticeFiles)
            }
            if(hoaDue?.newHoaDueFileToUpload && hoaDue.sourceId && hoaDue.sourceIdType == 'mail'){ 
                setSelectedFileFromMail(hoaDue.newHoaDueFileToUpload);
            }
            if(hoaDue?.newHoaDueFileToUpload && hoaDue.sourceId && hoaDue.sourceIdType == 'email'){ 
                setSelectedFileFromEmail(hoaDue.newHoaDueFileToUpload);
                setEmailFilesOptions(hoaDue.newHoaDueFileToUpload);
            }
            if(!hoaDue.hoaInfo){
                hoaDue['hoaInfo'] = [
                    {
                        hoaName: '',
                        hoaId: ''
                    }
                ]
            }
        }
    }, [hoaDue, open])

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const handleChange = (event: any) => {
		if (event?.date) {
            setHoaDue({
                ...hoaDue,
                [event.date.key]: event.date.value,
            })
		}else if(event?.check){
            setHoaDue({
                ...hoaDue,
                [event.check.key]: event.check.value,
            })
        } else {
            setHoaDue({
                ...hoaDue,
                [event.target.name]: event.target.value,
            })
		}
	};

    const deleteModalOpen = (idx: number) => {
        setIsOpen(true);
        setDocumentIndex(idx);
    }

    const handleDeleteModalClose = () => {
        setIsOpen(false);
    }

    const documentDelete = () => {
        const updatedFiles = files.filter((file: any, index: number) => index != documentIndex);
        
        const hoaDueCopy = JSON.parse(JSON.stringify(hoaDue));
        hoaDueCopy.hoaDuesNoticeFiles = updatedFiles;

        if (updatedFiles.length == 0) {
            setSourceIdStatus('');
        }
        setHoaDue(hoaDueCopy);
        handleDeleteModalClose();
    }

    const onSaveClick = () => {
        if(!hoaDue.invoiceDetails || !hoaDue.invoiceAmount || !hoaDue.sourceId){
            setError(true);
            return;
        }
        if(files.length <=0 && selectedFileFromEmail?.length <= 0 && (!selectedFileFromMail || selectedFileFromMail?.length <= 0)) {
            setError(true);
            return;
        }
        
        hoaDue.newHoaDueFileToUpload = hoaDue.sourceIdType == 'mail' ? selectedFileFromMail : hoaDue.sourceIdType == 'email' ? selectedFileFromEmail : null;
        setError(false);
        hoaDue.isDeleted = false;
        if(hoaDue.noticeStatus === undefined){
            hoaDue.noticeStatus = 'active'
        }
        if(Array.isArray(hoaDue.newHoaDueFileToUpload) && hoaDue.newHoaDueFileToUpload.length > 0) {
            const renamedFilesWithFees:any = [];
            for (const fileName of hoaDue.newHoaDueFileToUpload) {
                const fileExtension = getFileExtension(fileName);
                const valueInAccountingForm = getNegativeValueInAccountingForm(hoaDue?.invoiceAmount);
                const newFileName = `${valueInAccountingForm}.${fileExtension}`;
                renamedFilesWithFees.push(newFileName);
            }
                            
            hoaDue.newRenamedHoaDueFileToUpload = renamedFilesWithFees;
        }

        if(updateIndex != null){
            const tempHoaDueList = [...hoaDueList];
            tempHoaDueList[updateIndex] = hoaDue;
            setHoaDueLists(tempHoaDueList);
            onClose();
            setHoaDue({});
            setFiles([]);
            setUpdateIndex(null);
        } else {
            setHoaDueLists([hoaDue, ...hoaDueList])
            onClose();
            setHoaDue({});
            setFiles([]);
        }
    }

    const addNewHoaInfo = () => {
        const tempHoaDue = {...hoaDue};
        const newHoaInfo = {
            hoaName: '',
            hoaId: ''
        };
        tempHoaDue['hoaInfo'].push(newHoaInfo);
        setHoaDue(tempHoaDue);
    }

    const removeHoaInfo = (index: number) => {
        let tempHoaDue = {...hoaDue};
        tempHoaDue.hoaInfo = tempHoaDue.hoaInfo.filter((each: any, idx: number) => idx !== index);
        setHoaDue(tempHoaDue);
    }

    const handleHoaInfo = (index: number, key: string, value: string) => {
        const tempHoaDue = {...hoaDue};
        tempHoaDue.hoaInfo[index] = {
            ...tempHoaDue.hoaInfo[index],
            [key]: value
        }
        setHoaDue(tempHoaDue)
    }

    const getFilesBySourceId = async () => {
        if (hoaDue.sourceId && hoaDue.sourceIdType && propertyData.objectId) {
            setLoading(true);
            const result:any = await dashboardServices.getFilesBySourceId(hoaDue.sourceId, hoaDue.sourceIdType, propertyData.objectId);
            setLoading(false);

            if (Array.isArray(result?.data) && result.data.length > 0) {
                if (hoaDue.sourceIdType === 'mail' && Array.isArray(result.data) && result.data.length > 0) {
                    setSourceIdStatus("verified");
                    setSelectedFileFromMail(result.data);
                }
                else if (hoaDue.sourceIdType === 'email') {
                    setSourceIdStatus('');
                    setEmailFilesOptions(result.data);
                }
            }
            else {
                if (hoaDue.sourceIdType === 'email') {
                    setEmailFilesOptions([]);
                }
                setSourceIdStatus("error");
            }
        }
    }

    const isVerifyDisabled = () => {
        return (selectedFileFromEmail?.length > 0 || selectedFileFromMail || !hoaDue.sourceId || !hoaDue.sourceIdType
            || files?.length > 0
        );
    }
    const isSourceIdTypeDisabled = () => {
        return files?.length > 0 || selectedFileFromEmail?.length > 0 || selectedFileFromMail;
    }

    const isSourceIdDisabled = () => {
        return selectedFileFromEmail?.length > 0 || selectedFileFromMail || files?.length > 0;
    }

    const deleteSelectedFile = () => {
        setSelectedFileFromMail(null); 
        setSourceIdStatus(''); 
        setHoaDue({...hoaDue, newHoaDueFileToUpload: null, newRenamedViolationFileToUpload: null});
    }

    const handleSelectFileFromEmail = (event:any) => {
        const {
            target: { value },
        } = event;

        if (value.length > 0) {
            setSourceIdStatus('verified');
        }
        else {
            setSourceIdStatus('');
        }

        typeof value === 'string' ? value.split(',') : value,

        setSelectedFileFromEmail(value);
    }

    const handlePaymentEntityChange = (event:any) => {
        setHoaDue({
            ...hoaDue,
            paymentEntityInformation: {
                ...hoaDue.paymentEntityInformation,
                [event.target.name]: event.target.value
            }
        })
    }

	return (
        <>
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
                    overflowX: 'hidden'
				}}
			>
				 <div style={{background: "#EFF4FC", display: 'flex', justifyContent: 'space-between'}}>
					<div className="modal-title-container">
						<span className="text-3E3E3E-20px bold">{`${hoaDue.objectId ? 'Update' : 'Add'} Invoices`}</span>
						<span className="text-5B5B5B-14px  normal">
                            Please give necessary information to add invoices.
						</span>
					</div>
                    <div style={{padding: '24px', cursor: 'pointer'}} onClick={onClose}>
                        <CloseIcon />
                    </div>
                </div>
                <Card
                    variant="outlined"
                    className="violation-card-container"
                >
                    <Stack direction={"row"}>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginRight: "17px",
                                marginTop: "17px",
                            }}
                            label={"Invoice Details"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            value={hoaDue.invoiceDetails || ""}
                            name="invoiceDetails"
                            error={error && !hoaDue.invoiceDetails}
                            onChange={handleChange}
                        />
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginTop: "17px",
                            }}
                            label={"Invoice Amount"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            type='number'
                            value={hoaDue.invoiceAmount || ""}
                            name="invoiceAmount"
                            error={error && !hoaDue.invoiceAmount}
                            onChange={handleChange}
                            onWheel={e => Wheel(e)}
                        />
                    </Stack>
                    <Stack direction={"row"}>
                        <CustomDateField 
                            label="Notice Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                marginRight: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(hoaDue.noticeDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "noticeDate", value: value } })
                            }}
                        />
                        <CustomDateField 
                            label="Due Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(hoaDue.dueDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "dueDate", value: value } })
                            }}
                        />
                    </Stack>
                    <Stack>
                        <CustomDateField 
                            label="Hearing Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                marginRight: "17px",
                                width: "250px",
                                padding: "10px 0px"}}
                            value={dayjs(hoaDue.hearingDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "hearingDate", value: value } })
                            }}
                        />
                    </Stack>
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Hearing Details</span>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                marginTop: "17px",
                            }}
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="outlined"
                            value={hoaDue.hearingDetails || ""}
                            name="hearingDetails"
                            onChange={handleChange}
                        />
                    </Stack>
                    {/* Source id verification component */}
                    <SourceIdVerificationComp 
                        files={files}
                        error={error}
                        loading={loading}
                        violation={hoaDue}
                        handleChange={handleChange}
                        sourceIdStatus={sourceIdStatus}
                        deleteModalOpen={deleteModalOpen}
                        isVerifyDisabled={isVerifyDisabled}
                        emailFilesOptions={emailFilesOptions}
                        getFilesBySourceId={getFilesBySourceId}
                        deleteSelectedFile={deleteSelectedFile}
                        isSourceIdDisabled={isSourceIdDisabled}
                        selectedFileFromMail={selectedFileFromMail}
                        selectedFileFromEmail={selectedFileFromEmail}
                        isSourceIdTypeDisabled={isSourceIdTypeDisabled}
                        handleSelectFileFromEmail={handleSelectFileFromEmail}
                    />

                    <FormControl  style={{ width: "90%", margin:'14px'}} component="fieldset" variant="standard" >
                        <FormGroup style={{ display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                                <FormControlLabel
                                    style={{ fontSize: "10px" }}
                                    control={
                                        <Checkbox
                                            checked={hoaDue.isHighPriority === true}
                                            name="isHighPriority"
                                            sx={{
                                                color: "gray",
                                                "&.Mui-checked": {
                                                  color: "#c05142",
                                                },
                                            }}
                                            onChange={(e, v) =>
                                                handleChange({ check: { key: "isHighPriority", value: v } })
                                            }
                                        />
                                    }
                                    label={<Typography component={'span'} color={'#c05142'}>High Priority</Typography>}
                                />
                        </FormGroup>
                    </FormControl>
                    
                    <FormControl style={{ marginTop: "17px" }}>
                        <FormLabel style={{ fontSize: "14px" }}>Notice Status</FormLabel>
                        <RadioGroup name="noticeStatus" value={hoaDue.noticeStatus} onChange={handleChange} defaultValue="active" style={{ display: "flex", flexDirection: "row" }}>
                            <FormControlLabel
                                style={{ fontSize: "14px" }}
                                value="active"
                                control={<Radio />}
                                label="Active"
                            />
                            <FormControlLabel
                                style={{ fontSize: "14px" }}
                                value="resolved"
                                control={<Radio />}
                                label="Resolved"
                            />
                        </RadioGroup>
                    </FormControl>
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Remarks</span>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                marginTop: "17px",
                            }}
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="outlined"
                            value={hoaDue.remarks || ""}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Stack>

                    <Stack direction={`column`} marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Payment Entity Information</span>
                        <Stack direction={`row`}>
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginRight: "17px",
                                    marginTop: "10px",
                                }}
                                label={"Name"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={hoaDue.paymentEntityInformation?.name || ""}
                                name="name"
                                onChange={handlePaymentEntityChange}
                            />
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginTop: "10px",
                                }}
                                label={"Email"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={hoaDue.paymentEntityInformation?.email || ""}
                                name="email"
                                onChange={handlePaymentEntityChange}
                            />
                        </Stack>
                        <Stack direction={`row`}>
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginRight: "17px",
                                    marginTop: "10px",
                                }}
                                label={"Phone"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={hoaDue.paymentEntityInformation?.phone || ""}
                                name="phone"
                                onChange={handlePaymentEntityChange}
                            />
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginTop: "10px",
                                }}
                                label={"Address"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={hoaDue.paymentEntityInformation?.address || ""}
                                name="address"
                                onChange={handlePaymentEntityChange}
                            />
                        </Stack>
                        <Stack direction={`row`}>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginTop: "10px",
                                marginRight: "17px",
                            }}
                            label={"Website"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            value={hoaDue.paymentEntityInformation?.website || ""}
                            name="website"
                            onChange={handlePaymentEntityChange}
                        />
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginTop: "10px",
                            }}
                            label={"Mailing Address"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            value={hoaDue.paymentEntityInformation?.mailingAddress || ""}
                            name="mailingAddress"
                            onChange={handlePaymentEntityChange}
                        />
                         </Stack>
                    </Stack>

                    <Stack direction={`column`} marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">HOA Information</span>
                        {
                            hoaDue?.hoaInfo && hoaDue?.hoaInfo.map((item: any, index: number) => (
                                <Stack direction={`row`}>
                                <TextField
                                    style={{
                                        padding: "10px 0px",
                                        width: "250px",
                                        marginRight: "17px",
                                        marginTop: "17px",
                                    }}
                                    label={"HOA ID"}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    variant="standard"
                                    value={item.hoaId || ""}
                                    name="hoaId"
                                    onChange={(e) => handleHoaInfo(index, 'hoaId', e.target.value)}
                                />
                                <TextField
                                    style={{
                                        padding: "10px 0px",
                                        width: "250px",
                                        marginTop: "17px",
                                    }}
                                    label={"HOA Name"}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    variant="standard"
                                    value={item.hoaName || ""}
                                    name="hoaName"
                                    onChange={(e) => handleHoaInfo(index, 'hoaName', e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" style={{paddingBottom: '14px'}}>
                                                <IconButton>
                                                    {index === 0 ? <AddCircleOutline onClick={addNewHoaInfo} /> : <RemoveCircleOutline onClick={()=>removeHoaInfo(index)} />}
                                                </IconButton>
                                            </InputAdornment>
                                    )}}
                                />
                                </Stack>
                            ))
                        }
                    </Stack>
                    <Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={() => onClose()} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={() => onSaveClick()} variant="contained">
                            Save
                        </Button>
					</Stack>
                </Card>
			</Container>
		</Modal>
        <DeleteModal open={isOpen} onClose={handleDeleteModalClose} handleDelete={documentDelete}/>
        </>
	);
};

export default HoaDuesModal;

const DeleteModal = ({open, onClose, handleDelete}: any) => {
	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted forever</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={() => onClose()} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={handleDelete} variant="contained">
                            Delete
                        </Button>
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}